export type AdminSectionId = "users" | "gigs" | "reviews" | "feedback" | "issues" | "payments" | "notifications" | "audit";

export const adminSectionLabels: Record<AdminSectionId, string> = {
  users: "Users",
  gigs: "Gigs",
  reviews: "Reviews",
  feedback: "Feedback",
  issues: "Issues",
  payments: "Payments",
  notifications: "Notifications",
  audit: "Audit History",
};

export const adminUserTasks = [
  "Search users by email, name, role, and created date.",
  "Inspect verification state, guardian relationships, and profile completeness.",
  "Add tightly scoped support actions such as resend verification email.",
];

export const adminGigTasks = [
  "List gigs by status, poster, and created date.",
  "Inspect gig detail, attached media, and related requests.",
  "Add support-only moderation actions after audit logging is live.",
];

export const adminNotificationTasks = [
  "View pending, sent, and failed outbox items.",
  "Inspect last_error and attempt_count for failed deliveries.",
  "Requeue selected failed notifications with an admin reason.",
];

export const adminAuditTasks = [
  "Track admin user, action type, target type, target id, and timestamp.",
  "Require a reason for risky write actions where appropriate.",
  "Make audit history searchable so support actions can be reviewed later.",
];
